let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6KEX9")).then(() => parcelRequire('36y93'));